import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#0F0F0F] text-[#F3F2ED] flex flex-col">
      <Header />
      <main className="flex-grow flex items-center justify-center px-6">
        <div className="max-w-4xl text-center py-24">
          <h1 className="text-8xl md:text-9xl font-semibold tracking-tight leading-none mb-6">404</h1>
          <h2 className="text-3xl md:text-4xl font-medium mb-6">Page Not Found</h2>
          <p className="text-lg text-white/60 mb-8">Sorry, we couldn't find the page you're looking for. Try returning home or get in touch.</p>
          <div className="flex justify-center gap-6">
            <Link to="/" className="px-6 py-3 bg-white text-black font-medium rounded-sm hover:opacity-90 transition">Go Home</Link>
            <Link to="/contact-us" className="px-6 py-3 border border-white/20 text-white/90 rounded-sm hover:bg-white/5 transition">Contact Us</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
